import { ConfigService } from '@/configuration/services/configService';
import type { ISystemLinkContext } from '@/utils/resolveSystemLink';

/** Контекст разбора ссылок приложения: текущий адрес, базовый путь и адреса этой системы. */
export const getSystemLinkContext = (): ISystemLinkContext => ({
    baseUrl: window.location.href,
    basePath: import.meta.env.VITE_BASE_PATH,
    systemOrigins: ConfigService.get()?.application.systemLinkOrigins,
});
